<div class="header-row">
  <div class="header-campaign-info">
    <h1>
      {{ campaign().name }}
      @if (
        campaignStatus() &&
        campaignStatus()?.value < BrandCampaignStatusActiveValue
      ) {
        <mat-icon (click)="onCampaignNameEdit()">edit</mat-icon>
      }
    </h1>
    <div>
      <span class="campaign-type">{{
        "shared.campaignType." + campaign().type | translate
      }}</span>
      <div class="campaign-item-status">
        @if (campaignStatus(); as status) {
          <img
            alt="campaign-{{ status.label | translate }}"
            class="status-icon"
            src="/assets/images/icons/{{ status.icon }}.svg"
          />
          <span>{{ status.label | translate }}</span>
        }
      </div>
    </div>
  </div>
  <div class="view-type-list">
    <button
      mat-icon-button
      (click)="viewTypeChange.emit(ContentViewType.Grid)"
      [ngClass]="{ active: activeType() === ContentViewType.Grid }"
    >
      <mat-icon>apps</mat-icon>
    </button>
    <button
      mat-icon-button
      (click)="viewTypeChange.emit(ContentViewType.List)"
      [ngClass]="{ active: activeType() === ContentViewType.List }"
    >
      <mat-icon>format_list_bulleted</mat-icon>
    </button>
    <!--button
      class="btn btn--content-only"
      (click)="viewTypeChange.emit(ContentViewType.Detailed)"
    >
      <mat-icon>reorder</mat-icon>
    </button>
    <button
      class="btn btn--content-only"
      (click)="viewTypeChange.emit(ContentViewType.Calendar)"
    >
      <mat-icon>calendar_today</mat-icon>
    </button-->
  </div>
</div>
<div class="separator"></div>
